import { StoreObject, useMutation } from '@apollo/client'

import { GraphQLUtils } from 'utils'

import { UpdateRiceLot, UpdateRiceLotVariables, UPDATE_RICE_LOT } from './api'

export const useUpdateRiceLot = () => {
  const [updateRiceLot] = useMutation<UpdateRiceLot, UpdateRiceLotVariables>(UPDATE_RICE_LOT, {
    onError: GraphQLUtils.errorHandler,
    update: (cache, { data: response }) => {
      if (!response) return
      const seasonLot: StoreObject = {
        id: response.updateRiceLot.riceLot.id,
        __typename: 'SeasonLotRiceLot',
      }
      const {
        preparationDate,
        burningDate,
        plantingDate,
        emergenceDate,
        firstIrrigationStartDate,
        firstIrrigationEndDate,
        differentiationDate,
        floweringDate,
        earAppearanceDate,
        physiologicalMaturityDate,
        harvestDate,
        yield: yieldValue,
        emergenceUpdateType,
        plantingUpdateType,
        floweringUpdateType,
        harvestUpdateType,
        preparationUpdateType,
        burningUpdateType,
        earAppearanceUpdateType,
        differentiationUpdateType,
        estimatedYield,
      } = response.updateRiceLot.riceLot

      cache.modify({
        id: cache.identify(seasonLot),
        fields: {
          preparationDate: () => preparationDate ?? null,
          burningDate: () => burningDate ?? null,
          plantingDate: () => plantingDate ?? null,
          emergenceDate: () => emergenceDate ?? null,
          firstIrrigationStartDate: () => firstIrrigationStartDate ?? null,
          firstIrrigationEndDate: () => firstIrrigationEndDate ?? null,
          differentiationDate: () => differentiationDate ?? null,
          floweringDate: () => floweringDate ?? null,
          earAppearanceDate: () => earAppearanceDate ?? null,
          physiologicalMaturityDate: () => physiologicalMaturityDate ?? null,
          harvestDate: () => harvestDate ?? null,
          yield: () => yieldValue ?? null,
          emergenceUpdateType: () => emergenceUpdateType ?? null,
          plantingUpdateType: () => plantingUpdateType ?? null,
          floweringUpdateType: () => floweringUpdateType ?? null,
          harvestUpdateType: () => harvestUpdateType ?? null,
          preparationUpdateType: () => preparationUpdateType ?? null,
          burningUpdateType: () => burningUpdateType ?? null,
          earAppearanceUpdateType: () => earAppearanceUpdateType ?? null,
          differentiationUpdateType: () => differentiationUpdateType ?? null,
          estimatedYield: () => estimatedYield ?? null,
        },
      })
    },
  })

  return { updateRiceLot }
}
